import { useCallback } from "react";

export const useGetValueByCode = () => {
  const getValueByCode = useCallback((values: any, code: string) => {
    return values.find((item: any) => item.code === code);
  }, []);

  return { getValueByCode };
};
